<template>
    <div>
        <BreadCrumb :data="breadCrumb" />   
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <b-card v-else no-body class="formGroup">
            <b-tabs pills card>
                <b-tab title="Servis Bilgileri"  @click="pageSettings(false,'ServiceForm')">
                    <b-card-text class="formBox">
                        <ul class="info">
                                <li>
                                    <strong> Randevu Tarihi: </strong> 
                                    <span> 
                                        {{ dateFormat(serviceFormData.appointment_date)}}
                                    </span>
                                </li>
                                <li>
                                    <strong> Kayıt Tarihi: </strong> 
                                    <span> 
                                        {{ dateFormat(serviceFormData.reported_date)}}
                                    </span>
                                </li>
                                <li>
                                    <strong> Servis Tipi: </strong> 
                                    <span> 
                                        <b-badge variant="danger" v-if="serviceFormData.type == 'fault'"> Teknik Servis Hizmeti </b-badge>
                                        <b-badge variant="primary" v-else> Yeni Kurulum </b-badge>

                                    </span>
                                </li>
                                <li>
                                    <strong> Servis Durumu: </strong> 
                                    <span> 
                                        <b-badge variant="danger" v-if="serviceFormData.status == 'open'"> Açık </b-badge>
                                        <b-badge variant="success" v-else> Kapalı </b-badge>

                                    </span>
                                </li>
                                <li>
                                    <strong> Hizmet Alan Müşteri: </strong> 
                                    <span> {{serviceFormData.customer.name }} </span>
                                </li>
                                <li>
                                    <strong> Hizmet Veren Firma: </strong> 
                                    <span> {{serviceFormData.company.name }} </span>
                                </li>
                                <li>
                                    <strong> İlgili Ürün: </strong> 
                                    <span> {{serviceFormData.product.name }} </span>
                                </li>
                                <li>
                                    <strong> İlgili Teknisyen: </strong> 
                                    <span> 
                                        {{
                                            serviceFormData.user.first_name+' '+serviceFormData.user.last_name
                                        }}
                                    </span>
                                </li>
                                <li>
                                    <strong> Adres: </strong> 
                                    <span> 
                                        {{
                                            serviceFormData.customer.address+' '+serviceFormData.customer.town+' / '
                                            +serviceFormData.customer.city+' / '+ serviceFormData.customer.country
                                        }}
                                    </span>
                                </li>
                                <li style="width: 100%">
                                    <strong> Servis İçeriği: </strong> 
                                    <span v-html="serviceFormData.content" /> 
                                </li>
                            </ul>
                    </b-card-text>
                  
                </b-tab>
                
                <b-tab title="Harita Görünümü"  @click="pageSettings(false,'ServiceFormMap')">
                    <b-card-text>
                        <Map v-if="currentForm=='ServiceFormMap'" :address="serviceFormData.customer.address+' '+serviceFormData.customer.town+' '+serviceFormData.customer.city+' '+ serviceFormData.customer.country" />
                    </b-card-text>
                </b-tab>

                <b-tab style="padding: 0;" title="Hareketler" @click="pageSettings(true,'Movements')"> 
                    <b-card-body style="padding: 0;">
                        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" 
                        :actions="actions" :actionEvent="actionEvent" noHeader
                        />
                    </b-card-body>
                </b-tab>
            </b-tabs>
             <template v-slot:footer class="footer">
                <b-button variant="success" v-if="newButton" @click="$router.push({path:'/Dealer/ServiceForms/'+$route.params.id+'/Movements/Add'})">{{$t('general.add')}}</b-button>
                <b-button variant="warning" @click="openModal(true, 'report', {dealer: serviceFormData} )">Rapor Al</b-button>

            </template>
        </b-card>
         <!-- Modals -->
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Modals from './modals'
    import i18n from '@/plugins/i18n'
    import moment from 'moment'
    import Map from "@/components/Map";
    import Table from "@/components/Table"


    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.serviceForms'), url: '' }

    ]

    let fields = [ 
         { key: 'date', type: 'date', label: 'İşlem Tarihi', keys:['date']},
         { key: 'name', label: 'Yetkili Adı', keys:['person_name']},
         { key: 'surname', label: 'Yetkili Soyadı', keys:['person_surname'] },
         { key: 'desc', label: 'İşlem', keys:['description'] },
         { key: 'detection', label: 'Tespit', keys:['detection'] },
         { key: 'actions', label: i18n.t('dealer.list.actions') }        
    ]; 

    let actions = [
        {key: 'movement', text: 'Hareket Ekle', state: 0},
        {key: 'photo', text: "Harekete Ait Görüntüler", state: 0},
        {key: 'product', text: 'Harekete Ait Ürünler', state: 0}
    ]

    let filtered = ['date',"name", 'surname', 'desc', 'detection', 'actions']; 

    export default {
        name: "DealerEdit",
        created: function(){
             this.$store.dispatch('serviceFormDetail', {id: this.$route.params.id})
             this.$store.dispatch('serviceFormMovementList', {id: this.$route.params.id})

            
        },
        data: function(){
            return {
                breadCrumb,
                newButton: false,
                modalOpen: false,
                modalProps: {},
                currentForm:"ServiceForm",
                modalName: "",
                fields, filtered, actions
            }
        },
        components:{ BreadCrumb, Map, Table, Modals },
        computed: {
            loading(){
                return this.$store.getters.getDealerLoading
            },
            serviceFormData(){
                return this.$store.getters.getServiceFormDetail
            },
            list(){
                return this.$store.getters.serviceMovementsList
            },
            
        },
        methods:{
            pageSettings: async function(state, form){
                this.newButton = state
                this.currentForm = form
                

            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                this.modalProps = props
                this.modalName = modal
            },
            dateFormat(date){
                return moment(date).format('DD MMMM YYYY')
            },
        }
        
    }
</script>

<style lang="css" scoped> 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/ServiceDetail.vue